/**
 * @param {number} value
 * @param {number} decimals
 */
function roundNumber (value, decimals = 0) {
  if (!value && value !== 0) return
  return decimals
    ? parseFloat(value.toFixed(decimals))
    : parseInt(value.toFixed(0))
}

module.exports = { roundNumber }
